import { dmaCalculationResponseDtoSchema } from "@fonterra/dma-api-schema";
export const npdCalculationResponseDtoSchema = dmaCalculationResponseDtoSchema.omit({ metadata: true });
